module.exports = __webpack_public_path__ + "img/garansi-uang-kembali.dbe0102f.svg";